import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type QueryClient, type UseQueryResult } from "@tanstack/react-query";
import { minutesToMilliseconds } from "date-fns";

import {
  type GetShiftsStatsRequest,
  getShiftsStatsRequestSchema,
  type GetShiftsStatsResponse,
  getShiftsStatsResponseSchema,
} from "./schemas";

export const GET_SHIFTS_STATS_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/shifts/stats`;

export interface UseGetShiftsStatsOptions extends UseGetQueryOptions<GetShiftsStatsResponse> {}

export function useGetShiftsStats(
  queryParameters: GetShiftsStatsRequest | undefined,
  options?: UseGetShiftsStatsOptions
): UseQueryResult<GetShiftsStatsResponse> {
  return useGetQuery({
    url: GET_SHIFTS_STATS_URL,
    queryParams: queryParameters as GetShiftsStatsRequest,
    requestSchema: getShiftsStatsRequestSchema,
    responseSchema: getShiftsStatsResponseSchema,
    staleTime: minutesToMilliseconds(5),
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_SHIFTS_STATS_FAILURE,
    },
    enabled: isDefined(queryParameters),
    ...options,
  });
}

export function invalidateGetShiftsStats(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({
    queryKey: [GET_SHIFTS_STATS_URL],
  });
}
